import SearchService from "../services/search";
import ContentService from "../services/contentUnauth";
import * as types from "../actions/ActionTypes";
import { store } from "../storage/store";

export const search = (params, isFilter = false) => {
  const secret = store.getState().authReducer.secret;
  const service = new SearchService(secret);

  return {
    type: types.SEARCH,
    payload: service["query"](params, store.getState().searchReducer.searchPage, isFilter),
  };
};

export const searchFiltered = (params) => {
  const secret = store.getState().authReducer.secret;
  const service = new SearchService(secret);

  return {
    type: types.SEARCH,
    payload: service["searchFiltered"](params),
  };
};

export const setSearching = () => {
  return {
    type: types.SEARCH_SHOW,
  };
};

export const dismissSearch = () => {
  return {
    type: types.SEARCH_HIDE,
  };
};

export const searchFilter = (params) => {
  return {
    type: types.SEARCH_FILTER,
    payload: params,
  };
};

export const searchPage = (params) => {
  return {
    type: types.SEARCH_PAGE,
    payload: params,
  };
};

export const searchKey = (params) => {
  return {
    type: types.SEARCH_KEY,
    payload: params,
  };
};

export const setSearchValue = (value) => {
  return {
    type: types.SEARCH_VALUE,
    payload: value,
  };
};

export const searchByMood = (params) => {
  const secret = store.getState().authReducer.secret;
  const service = new ContentService(secret);
  return {
    type: types.SEARCH_MOOD,
    payload: service["getByCategory"](params),
  };
};
